module.exports = __webpack_public_path__ + "img/line.c9d7af84.svg";